// src/pages/dashbord/section/OrdersSection.tsx
import React from 'react';
import { Card, Row, Col } from 'antd';
import { ShoppingCartOutlined } from '@ant-design/icons';
import OrdersKPI from '../../../components/OrdersKPI';
import OrdersSplitDonut from '../../../components/OrdersSplitDonut';
import OrdersAllTimeChart from '../../../components/OrdersAllTimeChart';
import OrdersItemsFromNotifications from '../../../components/OrdersItemsFromNotifications';
import OrdersExportButton from '../../../components/OrdersExportButton';
import StatusChips from '../../../ui/StatusChips';
import TableHeader from '../../../components/TableHeader';

type Props = {
  ordersFiltered: any[];
  ordersSeries: Array<{ date: string; count: number; cumulative: number }>;
  visibleOrderStatuses: string[];
  orderStatusCountsAll: Record<string, number>;
  isOrderStatusActive: (st: string) => boolean;
  onToggleOrderStatus: (key: string) => void;
  ordersSearch: string;
  onOrdersSearchChange: (s: string) => void;
  onResetColumns: () => void;
  colsVer: number;
  getStatusMeta: (st: string) => { chip: { label: string; bg: string; fg: string } };
  ORDER_STATUS_LIST: readonly string[];
};

const OrdersSection: React.FC<Props> = ({
  ordersFiltered,
  ordersSeries,
  visibleOrderStatuses,
  orderStatusCountsAll,
  isOrderStatusActive,
  onToggleOrderStatus,
  ordersSearch,
  onOrdersSearchChange,
  onResetColumns,
  colsVer,
  getStatusMeta,
  ORDER_STATUS_LIST,
}) => {
  return (
    <>
      <div style={{ marginTop: 16 }}>
        <OrdersKPI source={ordersFiltered as any} />
      </div>

      <Row gutter={[16, 16]} style={{ marginTop: 28 }}>
        <Col xs={24} md={12} lg={10}>
          <OrdersSplitDonut height={420} rangeDays={30} />
        </Col>
        <Col xs={24} md={12} lg={14}>
          <OrdersAllTimeChart data={ordersSeries} height={420} />
        </Col>
      </Row>

      <Card
        variant="borderless"
        className="stat-card stat-card--accent-blue"
        style={{ marginTop: 16 }}
        styles={{ header: { paddingTop: 14, paddingBottom: 14, alignItems: 'center' } }}
       title={
          <TableHeader
            icon={<ShoppingCartOutlined />}
            title="Заказанные товары"
            chips={
              <StatusChips
                metas={visibleOrderStatuses.map((st) => {
                  const m = getStatusMeta(st);
                  return { key: st, label: m.chip.label, bg: m.chip.bg, fg: m.chip.fg };
                })}
                counts={orderStatusCountsAll}
                activeKeys={ORDER_STATUS_LIST.filter(st => isOrderStatusActive(st as any))}
                onToggle={(key) => onToggleOrderStatus(key as any)}
                hideZero
              />
            }
            totalLabel="Всего заказов"
            totalValue={ordersFiltered.length}
            searchPlaceholder="Номер заказа"
            searchValue={ordersSearch}
            onSearchChange={onOrdersSearchChange}
            onResetColumns={onResetColumns}
            exportButton={<OrdersExportButton className="header-action-btn" source={ordersFiltered} />}
          />
        }
      >
        <OrdersItemsFromNotifications key={colsVer} source={ordersFiltered} maxRows={Number.POSITIVE_INFINITY} />
      </Card>
    </>
  );
};

export default OrdersSection;
